export default __webpack_public_path__ + "static/new7-09-4cc5d09eaa2579bb275603cf4341809c.jpg";